/** An option of the `Select` component. */
export interface SelectOption {
  value: string;
  label: string;
}

/** Options of plain string items, each its own label. */
export const optionsOf = (items: readonly string[]): SelectOption[] =>
  items.map((item) => ({ value: item, label: item }));
